import * as util from '#packages/util';
import type { AppData } from '../components/privateAppsProvider/privateAppsProvider';
import { getAppVersion } from './utils';

export const editInBlocks = (appDefinitionId: string, httpReferrer: string) => {
  window.open(
    util.appStudioUtils.createEditAppURL(
      {
        appDefinitionId,
      },
      httpReferrer,
    ),
    '_blank',
  );
};

export const hasCodePackage = ({ components }: AppData) =>
  components?.some(({ type }) => type === 'CODE_PACKAGE');

export const hasMajorUpdate = (app: AppData) =>
  app.latestVersion &&
  util.appStudioUtils.isMajorUpdate(getAppVersion(app), app.latestVersion);

export const hasUpdates = (app: AppData) =>
  app.latestVersion && app.latestVersion !== getAppVersion(app);
